import React, { createContext, useContext, useState } from 'react';
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';

interface BreadcrumbItem {
  breadcrumb: string;
  path: string;
}

interface BreadcrumbsContextType {
  breadcrumbs: BreadcrumbItem[];
  updateBreadcrumbs: (newBreadcrumbs: BreadcrumbItem[]) => void;
}

const BreadcrumbsContext = createContext<BreadcrumbsContextType>({
  breadcrumbs: [],
  updateBreadcrumbs: () => { },
});

export const BreadcrumbsProvider = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);

  const updateBreadcrumbs = (newBreadcrumbs: BreadcrumbItem[]) => {
    setBreadcrumbs(newBreadcrumbs);
  };

  return (
    <BreadcrumbsContext.Provider value={{ breadcrumbs, updateBreadcrumbs }}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};

export const useBreadcrumbs = () => useContext(BreadcrumbsContext);
